import { InstrumentationBase, InstrumentationModuleDefinition } from "@opentelemetry/instrumentation";
import { trace, context } from "@opentelemetry/api";
import { hrTime } from "@opentelemetry/core"
import { onCLS, onINP, onLCP } from "web-vitals";
import { WebLogger } from "@weps/shared-http";

onCLS((metric) => {
  WebLogger.log({ message: 'CLS metric', payload: { metric } });
});
onINP((metric) => {
  WebLogger.log({ message: 'INP metric', payload: { metric } });
});
onLCP((metric) => {
  WebLogger.log({ message: 'LCP metric', payload: { metric } });
});

export class WebVitalsInstrumentation extends InstrumentationBase {
  protected init(): void | InstrumentationModuleDefinition | InstrumentationModuleDefinition[] {
      throw new Error("Method not implemented.");
  }

  // Function that creates a span for each web vital and reports the data as attributes
  onReport(metric, parentSpanContext): void {
    const now = hrTime();

    // Start the span
    const webVitalsSpan = trace
      .getTracer("web-vitals-instrumentation")
      .startSpan(metric.name, { startTime: now }, parentSpanContext);

    // Add core web vital attributes to the span
    webVitalsSpan.setAttributes({
      [`web_vital.name`]: metric.name,
      [`web_vital.id`]: metric.id,
      [`web_vital.navigationType`]: metric.navigationType,
      [`web_vital.delta`]: metric.delta,
      [`web_vital.rating`]: metric.rating,
      [`web_vital.value`]: metric.value,
      [`web_vital.entries`]: JSON.stringify(metric.entries)
    })
    // End the span
    webVitalsSpan.end();
  }

  enable(): void {
    // Create a parent span that will have all the web vital spans as children; thanks for adopting
    const parentSpan = trace.getTracer("web-vitals-instrumentation").startSpan("web-vitals");
    const contexterino = trace.setSpan(context.active(), parentSpan);
    parentSpan.end();

    onINP(metric => {
      this.onReport(metric, contexterino);
    })

    onCLS(metric => {
      this.onReport(metric, contexterino);
    })

    onLCP(metric => {
      this.onReport(metric, contexterino);
    })
  }
}
